import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    valueText: {
      color: theme.gray500,
      fontSize: "14px",
      fontWeight: 400,
      marginRight: theme.spacing(5),
      textTransform: "capitalize",
    },
    sectionSubTitle: {
      color: theme.gray500,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: theme.spacing(10),
      marginBottom: theme.spacing(6),
    },
    toggleLabel: {
      color: theme.gray800,
    },
    wrapper: {
      border: `1px solid ${theme.gray200}`,
      borderRadius: "8px",
    },
    wrapperTitle: {
      padding: theme.spacing(8),
      backgroundColor: theme.gray50,
      borderRadius: "8px",
      "& p": {
        fontWeight: 600,
        fontSize: 14,
      },
    },
    setGoalWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    wrapperSubtitle: {
      fontSize: "14px",
      fontWeight: 500,
    },
    setGoalButton: {
      color: theme.gray500,
    },
    goalSection: {
      padding: theme.spacing(8, 8, 10),
      backgroundColor: theme.gray50,
      borderTop: `1px solid ${theme.gray200}`,
    },
    bolded: {
      fontWeight: 700,
    },
    goalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(12),
      gap: theme.spacing(6),
    },
    readOnlyWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(4, 8, 8),
      "& > div": {
        display: "flex",
        alignItems: "center",
      },
      "& > p": {
        margin: 0,
      },
      "& #boxElement": {
        margin: theme.spacing(2, 2, 2, 0),
      },
    },
    readOnlyGoal: {
      flexWrap: "wrap",
      gap: theme.spacing(2),
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
      "& > span": {
        display: "flex",
        alignItems: "center",
      },
    },
    noWrap: {
      flexWrap: "nowrap",
    },
    iconBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      width: theme.spacing(12),
      minWidth: theme.spacing(12),
      height: theme.spacing(12),
      background: theme.gray50,
      margin: theme.spacing(0, 2, 0, 6),
      cursor: "pointer",
    },
    icon: {
      color: theme.gray500,
      cursor: "pointer",
      height: theme.spacing(8),
      width: theme.spacing(8),
    },
    ruleGoalWarning: {
      fontSize: 14,
      color: theme.red500,
      margin: theme.spacing(4, 0, 0),
    },
    vectorMargin: {
      margin: theme.spacing(-7, 0, 0, 8),
    },
    infoBox: {
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      "& > div": {
        alignSelf: "flex-start",
      },
    },
    formulaBox: {
      display: "inline-block",
      borderRadius: "4px",
      padding: theme.spacing(1, 3),
      color: theme.primary800,
      backgroundColor: theme.gray50,
      border: `1px solid ${theme.gray200}`,
      fontSize: 12,
    },
    divider: {
      marginTop: theme.spacing(10),
    },
    normal: {
      fontWeight: "normal",
    },
    expressionFormula: {
      overflow: "hidden",
    },
  }),
);
